'use strict';

export default angular
  .module('maestro.filters.recipientsStr', [])

  .filter('recipientsStr', function() {
    return function(o) {
      let str = '';
      // str += o.orgsStr;
      // str += o.groupsStr;
      // str += o.usersStr;
      if (o.orgs && o.orgs.length > 0) {
        str += o.orgsStr + ', ';
      }
      if (o.groups && o.groups.length > 0) {
        str += o.groupsStr + ', ';
      }
      if (o.users && o.users.length > 0) {
        str += o.usersStr + ', ';
      }
      return str.substr(0, str.length - 2);
    };
  })

  .name;
